import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguro-mutual',
  templateUrl: './seguro-mutual.component.html',
  styleUrls: ['./seguro-mutual.component.css']
})
export class SeguroMutualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
